/* RESPONSIBLE TEAM: team-reporting */
/**
 * Append _ooo to field name if withinOfficeHours is true
 */
export const officeHoursField = (field, withinOfficeHours) => {
  return withinOfficeHours ? `${field}_ooo` : field;
};

export const botInboxAndOfficeHoursField = (field, withinOfficeHours, excludeBotInbox) => {
  let updatedField = excludeBotInbox ? `${field}_excluding_bot_inbox` : field;
  return officeHoursField(updatedField, withinOfficeHours);
};

export const timeTimeToCloseField = (excludeBotInbox) =>
  excludeBotInbox ? 'time_to_close' : 'time_to_close_from_initial_user_part';
